import React from "react";
import TransferBalanceButtonProperties from "./TransferBalanceButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import TransferBalanceStore from "./TransferBalanceStore";
import PaidIcon from "@mui/icons-material/Paid";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./TransferBalanceButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import Currency from "../../../entities/Currency";
import CurrencySelect from "../../Selects/CurrencySelect/CurrencySelect";
import CommentInput from "../../Inputs/CommentInput/CommentInput";
import Alert from "../../../ui_components/Alert/Alert";
import AlertType from "../../../ui_components/Alert/AlertType";
import PriceInput from "../../Inputs/PriceInput/PricetInput";
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import DeliveryPersonSelect from "../../Selects/DeliveryPersonSelect/DeliveryPersonSelect";
import DeliveryPerson from "../../../entities/DeliveryPerson";

const TransferBalanceButton: React.FC<TransferBalanceButtonProperties> = ({
                                                                              onClick = () => {
                                                                              },
                                                                              onSave = () => {
                                                                              },
                                                                              showIcon = true,
                                                                              showText = true,
                                                                              disabled,
                                                                              className = "",
                                                                              rounded = false,
                                                                              size = ButtonSize.DEFAULT,
                                                                              type = ButtonType.DEFAULT,
                                                                          }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const userStore = useUserContext();
    const commonContext = useCommonContext();
    const store = new TransferBalanceStore(commonContext);

    if (!userStore.hasAccess(Access.TRANSFER_BALANCE_BETWEEN_DELIVERY_PERSON.valueOf())) {
        return <></>;
    }

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    };

    const onCloseModal = () => {
        store.error = undefined;
        store.success = undefined;
        store.currencyError = undefined;
        store.amountError = undefined;
        store.closeModal();
        if (onSave) {
            onSave();
        }
    };

    const onCurrencyChange = (newCurrency: Currency) =>
        (store.currency = newCurrency);
    const onAmountChange = (newAmount: number) => (store.amount = newAmount);
    const onCommentChange = (newComment: string) => (store.comment = newComment);
    const onFromChange = (d?: DeliveryPerson) => (store.from = d);
    const onToChange = (d?: DeliveryPerson) => (store.to = d);

    const onBalanceSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.cleanModal();
            store.error = undefined;
            store.currencyError = undefined;
            store.amountError = undefined;
            store.success = "OK";
            // onCloseModal();
        } else {
            store.success = undefined;
            if (!store.amount || !store.currency) {
                store.error = undefined;
            } else {
                store.error = "INTERNAL_ERROR";
            }
        }
    };

    const basicText = i18n.translate("TRANSFER_BALANCE");
    const Icon = PaidIcon;
    const Btn = () => {
        if (rounded) {
            return (
                <RoundedButton
                    onClick={handleOnclick}
                    className={className}
                    disabled={disabled}
                    tooltip={!showText ? basicText : ""}
                    text={showText ? basicText : ""}
                    type={type}
                    icon={showIcon ? <Icon/> : <></>}
                />
            );
        }
        return (
            <Button
                text={showText ? basicText : ""}
                className={className}
                tooltip={!showText ? basicText : ""}
                disabled={disabled}
                size={size}
                onClick={handleOnclick}
                type={type}
                startIcon={showIcon ? <Icon/> : <></>}
            />
        );
    };
    return (
        <Observer>
            {() => (
                <>
                    <Modal
                        fullScreen={false}
                        loading={store.loading}
                        title={basicText}
                        onClose={onCloseModal}
                        open={store.isModalOpen}
                    >
                        <div className={classes.modal_container}>
                            <DeliveryPersonSelect
                                fullWidth
                                label={i18n.translate("FROM_USER")}
                                className={classes.input}
                                selected={store.from}
                                onChange={onFromChange}/>
                            <DeliveryPersonSelect
                                fullWidth
                                label={i18n.translate("TO_USER")}
                                className={classes.input}
                                selected={store.to}
                                onChange={onToChange}/>
                            <PriceInput
                                fullWidth
                                label={i18n.translate("BALANCE")}
                                className={classes.input}
                                value={store.amount}
                                error={i18n.translate(store.amountError)}
                                onChange={onAmountChange}
                            />
                            <CurrencySelect
                                fullWidth
                                selected={store.currency}
                                error={i18n.translate(store.currencyError)}
                                className={classes.input}
                                onChange={onCurrencyChange}
                            />
                            <CommentInput
                                lines={3}
                                onChange={onCommentChange}
                                fullWidth
                                value={store.comment}
                                className={classes.input}
                            />
                            {store.error && (
                                <Alert
                                    className={classes.alert}
                                    text={`${i18n.translate("ERROR")}`}
                                    type={AlertType.DANGER}
                                />
                            )}
                            {store.success && (
                                <Alert
                                    className={classes.alert}
                                    text={`${i18n.translate("SUCCESS")}`}
                                    type={AlertType.SUCCESS}
                                />
                            )}
                            <Button
                                loading={store.loading}
                                className={classes.input}
                                onClick={onBalanceSave}
                                disabled={!store.enableButton}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}
                            />
                        </div>
                    </Modal>
                    <Btn/>
                </>
            )}
        </Observer>
    );
};

export default TransferBalanceButton;
